import { ChildInfoComponent } from './../project/pages/create/components/child-info/child-info.component';
import { NgModule } from '@angular/core';
import { ProjectComponent } from './project.component';
import { SharedModule } from '@shared/shared.module';
import { PhotosComponent } from './pages/create/components/photos/photos.component';
import { DescriptionComponent } from './pages/create/components/description/description.component';
import { CreateComponent } from './pages/create/create.component';
import { AdditionalInfoComponent } from './pages/create/components/additional-info/additional-info.component';

@NgModule({
  declarations: [
    ProjectComponent,
    PhotosComponent,
    DescriptionComponent,
    CreateComponent,
    AdditionalInfoComponent,
    ChildInfoComponent,
  ],
  exports: [AdditionalInfoComponent, ChildInfoComponent],
  imports: [SharedModule],
})
export class ProjectModuleWithoutRouting {}
